import { render, staticRenderFns } from "./ClassificationManagement.vue?vue&type=template&id=708e2e9d"
import script from "./ClassificationManagement.vue?vue&type=script&lang=js"
export * from "./ClassificationManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports